<!--
   Created by qing on 2020/3/4 5:51 下午
   Des:
-->
<template>
  <van-popup
    v-model="visible"
    :style="{ height: '90%', width: '100%' }"
    get-container="body"
    closeable
    position="bottom">
    <div class="clash-popup">

      <div class="clash-container" v-if="formSet">
        <div class="header">
          <div style="color: red; line-height: 20px">
            系统检测到 在您所提交数据之前已经有人更新，所以请你进行确认并提交
          </div>
          <div class="legend-container">
            <span class="title">图例</span>
            <div class="legend-content">
              <div class="legend-item">
                <i class="el-icon-remove-outline" style="color: #19be6b;"></i>
                <span>允许提交</span>
              </div>
              <div class="legend-item">
                <i class="el-icon-warning-outline" style="color: #FF8773;"></i>
                <span>发现冲突</span>
              </div>
              <div class="legend-item">
                <i class="el-icon-circle-check" style="color: #ff9900;"></i>
                <span>已解决冲突</span>
              </div>
            </div>
          </div>
          <van-checkbox
            v-model="showAllFields"
            shape="square"
            icon-size="16px"
            checked-color="#4A66FA">
            显示所有控件
          </van-checkbox>
        </div>
        <div class="data-clash-content">
          <div
            class="clash-sectional"
            v-for="section in showAllFields ? allFieldList : clashList"
            :key="Math.random()">
            <div
              class="item"
              v-for="item in section"
              :key="item.currentField.dataId">
              <div
                class="current-data"
                :class="{'fix-background' : item.status === 'fix' && item.fixField === item.currentField,
                 'clash-background' : item.status === 'clash',
                 'no-fix-background': item.status === 'fix' && item.fixField !== item.currentField}">

                <div class="data-indicator">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div>
                  <div class="header-current-data">
                    <div>
                      <div class="tips">您将要提交的数据</div>
                      <div class="tips">您可以在这里进行手动更新操作</div>
                    </div>
                    <van-button
                      class="handle-button"
                      v-if="item.status === 'clash' || item.status === 'fix'"
                      type="primary"
                      size="small"
                      @click="fixClash(item, item.currentField)">
                      以我为准
                    </van-button>
                  </div>
                  <div
                    class="field-fix-indicator"
                    :style="{backgroundColor : item.status === 'clash' ? '#FF8773' : '#ff9900'}"
                    v-if="item.status === 'clash' || (item.status === 'fix' && item.fixField === item.currentField)">
                  </div>
                  <div class="field-item">
                    <component
                      :is="`control_${item.currentField.type}`"
                      :type="FORM_STATUS__FILL"
                      :value="item.currentField">
                    </component>
                  </div>
                </div>
              </div>
              <div class="indicator">
                <div></div>
                <i v-if="item.status === 'none'" class="el-icon-remove-outline" style="color: #19be6b;"></i>
                <i v-if="item.status === 'clash'" class="el-icon-warning-outline" style="color: #FF8773;"></i>
                <i v-if="item.status === 'fix'" class="el-icon-circle-check" style="color: #ff9900;"></i>
                <div></div>
              </div>
              <div
                class="history-data"
                :class="{'fix-background' : item.status === 'fix' && item.fixField === item.historyField,
                 'clash-background' : item.status === 'clash',
                 'no-fix-background': item.status === 'fix' && item.fixField !== item.historyField}">

                <div class="history-data-indicator">
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
                <div>
                  <div class="header-history-data">
                    <div>
                      <div class="tips">服务器最新的数据</div>
                      <div class="tips">
                        <van-image
                          style="margin-right: 10px"
                          width="25"
                          height="25"
                          :src="lastReviseUser.headImg">
                        </van-image>
                        {{lastReviseUser.nickname}}
                        <div style="margin-left: 10px">
                          {{lastReviseTime}}修改
                        </div>
                      </div>
                    </div>
                    <van-button
                      class="handle-button"
                      v-if="item.status === 'clash' || item.status === 'fix'"
                      type="primary"
                      size="small"
                      @click="fixClash(item, item.historyField)">
                      以我为准
                    </van-button>
                  </div>
                  <div
                    class="field-fix-indicator"
                    :style="{backgroundColor : item.status === 'clash' ? '#FF8773' : '#ff9900'}"
                    v-if="item.status === 'clash' || (item.status === 'fix' && item.fixField === item.historyField)">
                  </div>
                  <div class="field-item">
                    <component
                      :is="`control_${item.historyField.type}`"
                      :type="FORM_STATUS__READ"
                      :value="item.historyField">
                    </component>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <van-button
          size="small"
          @click="visible = false">
          取 消
        </van-button>
        <van-button
          size="small"
          type="primary"
          @click="submitData">
          提交
        </van-button>
      </div>
    </div>

    <van-dialog
      v-model="innerVisible"
      title="你还有以下未解决的冲突，解决后提交"
      @confirm="mandatorySubmitData"
      confirm-button-text="强制提交"
      cancel-button-text="去修改"
      show-cancel-button>
      <div style="margin-top: 10px">
        <div
          style="margin-bottom: 10px; margin-left: 10px"
          v-for="(item, idx) in notSolvedClashList"
          :key="item.currentField.dataId">
          {{idx + 1}}、{{item.currentField.fieldTitle}}
        </div>
      </div>
    </van-dialog>
  </van-popup>
</template>

<script>
  import {
    FORM_ITEM__SECTION,
    FORM_ITEM__TABLE,
    FORM_STATUS__FILL,
    FORM_STATUS__READ,
    FORM_TYPE__FILL
  } from "../RyForm/types"
  import control from "../RyForm/control/index"
  import {formatDate} from "../../assets/js/Untis"

  export default {
    data() {
      return {
        FORM_STATUS__FILL,
        FORM_STATUS__READ,
        formKey: Math.random(),
        visible: false,
        showAllFields: false,
        context: null,
        formSet: null,
        clashData: null,
        changeList: [],
        historyFormSet: null,
        allFieldList: [],
        clashList: [],
        innerVisible: false,
        notSolvedClashList: [],
      };
    },
    components: {
      ...control
    },
    computed: {
      lastReviseUser() {
        const item = this.changeList[0]
        if (item) {
          return this.$store.getters.userListMap[item.userId]
        } else {
          return {}
        }
      },
      lastReviseTime() {
        const item = this.changeList[0]
        if (item) {
          return formatDate(item.lastVersion)('yyyy-MM-dd HH:mm')
        } else {
          return ''
        }
      }
    },
    methods: {
      open({formSet, clashData, changeList, context}) {
        this.context = context
        this.formSet = formSet
        this.clashData = clashData
        this.changeList = changeList
        this.formKey = Math.random()
        this.historyFormSet = formSet.clone()
        this.historyFormSet.setValues(clashData)
        this.historyFormSet.status = FORM_STATUS__READ
        this.allFieldList = []
        this.clashList = []

        let changeMap = {}
        changeList.map(item => {
          changeMap[item.fieldId] = item
        })

        this.allFieldList.splice(0, this.allFieldList.length)

        this.formSet.children.forEach(item => {
          let children = []
          item.children.forEach(field => {
            children.push({
              currentField: field,
              status: changeMap[field.dataId] ? 'clash' : 'none',
              clashInfo: changeMap[field.dataId],
              historyField: this.historyFormSet.fields[field.dataId],
              fixField: null
            })
          })
          this.allFieldList.push(children)
          this.clashList.push(children.filter(f => f.status === 'clash'))
        })
        this.visible = true
      },
      hasGetValue(item) {
        return item &&
          item.type !== FORM_ITEM__SECTION&&
          item.parent.type !== FORM_ITEM__TABLE &&
          item.getValue
      },
      // 解决冲突
      fixClash(item, field) {
        item.status = 'fix'
        item.fixField = field
      },
      // 提交数据
      submitData() {
        this.notSolvedClashList.splice(0, this.notSolvedClashList.length)
        this.clashList.forEach(item => {
          item.forEach(f => {
            if (f.status === 'clash') {
              this.notSolvedClashList.push(f)
            }
          })
        })
        // 判断是否解决完冲突
        if (this.notSolvedClashList.length > 0) {
          this.innerVisible = true
        } else {
          let data = {}
          this.allFieldList.forEach(item => {
            item.forEach(f => {
              if (f.fixField) {
                if (this.hasGetValue(f.fixField)) {
                  data[f.fixField.dataId] = f.fixField.getValue()
                }
              } else {
                if (this.hasGetValue(f.currentField)) {
                  data[f.currentField.dataId] = f.currentField.getValue()
                }
              }
            })
          })
          this.innerVisible = false
          this.showAllFields = false
          this.visible = false
          this.$emit('fixComplete', {
            context: this.context,
            changeList: this.changeList,
            data
          })
        }
      },
      // 强制提交数据
      mandatorySubmitData() {
        let data = {}
        this.allFieldList.forEach(item => {
          item.forEach(f => {
            if (f.fixField) {
              if (this.hasGetValue(f.fixField)) {
                data[f.fixField.dataId] = f.fixField.getValue()
              }
            } else {
              if (this.hasGetValue(f.currentField)) {
                data[f.currentField.dataId] = f.currentField.getValue()
              }
            }
          })
        })
        this.innerVisible = false
        this.showAllFields = false
        this.visible = false
        this.$emit('fixComplete', {
          context: this.context,
          changeList: this.changeList,
          data
        })
      }
    }
  };
</script>

<style lang="less">

  .clash-popup {
    margin-top: 44px;
    height: calc(100% - 44px);

    .header {
      padding: 0 10px 5px 10px;
      font-size: 14px;
      color: #282828;
      border-bottom: 1px dashed #e6e6e6;
    }

    .clash-container {
      height: calc(100% - 44px);
      overflow: auto;

      .legend-container {
        margin: 10px 0;

        .title {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 5px;
        }

        .legend-content {
          display: flex;
          margin-top: 10px;

          .legend-item {
            margin-right: 10px;
          }
        }
      }

      .el-checkbox {
        margin-bottom: 20px;
      }

      .data-clash-content {
        margin-top: 10px;
        overflow: hidden;

        .item {
          display: flex;
          flex-direction: column;
          border-bottom: 1px dashed #e6e6e6;
          padding-bottom: 5px;
          margin-top: 5px;

          .fix-background {
            background-color: #FFE8CD;
          }

          .clash-background {
            background-color: rgba(255, 135, 115, 0.2);
          }

          .no-fix-background {
            background-color: #F6F6F6;
          }

          .field-item {
            width: 100%;
            padding: 10px 20px;
          }

          .handle-button {
            margin-left: 20px;
            margin-right: 10px;
          }

          .current-data,
          .history-data {
            width: 100%;
            display: flex;

            .data-indicator {
              width: 30px;
              display: flex;
              flex-direction: column;

              >:nth-child(1) {
                height: 50%;
              }
              >:nth-child(2) {
                height: 1px;
                width: 50%;
                margin-left: 15px;
                background-color: #e6e6e6;
              }
              >:nth-child(3) {
                flex: 1;
                width: 1px;
                margin-left: 15px;
                background-color: #e6e6e6;
              }
            }

            .history-data-indicator {
              width: 30px;
              display: flex;
              flex-direction: column;

              >:nth-child(1) {
                height: 50%;
                width: 1px;
                margin-left: 15px;
                background-color: #e6e6e6;
              }

              >:nth-child(2) {
                height: 1px;
                width: 50%;
                margin-left: 15px;
                background-color: #e6e6e6;
              }
            }

            > :nth-child(2) {
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 100%;

              .field-fix-indicator {
                width: 10px;
                height: 100%;
                background-color: #ff9900;
              }

              .header-current-data,
              .header-history-data {
                display: flex;
                justify-content: space-between;
                margin-top: 10px;
                width: 100%;
                margin-left: 10px;

                .tips {
                  font-size: 12px;
                  color: #282828;
                }
              }
            }
          }

          .indicator {
            width: 100%;
            display: flex;
            flex-direction: column;
            height: 50px;

            i {
              height: 30px;
              font-size: 30px;
            }

            div {
              height: 10px;
              width: 1px;
              background-color: #e6e6e6;
              margin-left: 15px;
            }
          }
        }

        .ry-form__section.ry-form__section-fill {
          box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0);
        }
      }
    }

    .footer {
      height: 44px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .van-button {
        margin-right: 10px;
      }
    }
  }


</style>